import { MouseEvent } from 'react'
import NextImage from 'next/image'
import { getLink } from '@helpers/env'
import { getIsFirstTimeUser } from '@helpers/session/user'
import SectionHeader from '@components/ui/SectionHeader'
import styles from '../../../components/LandingPageProductsCards/styles.module.scss'
import { analytics } from '@helpers/analytics'

const CARDS: Card[] = [
  {
    title: 'Sharps',
    image: '/static/images/enduros/products-breakdown-sharps.jpg',
    handle: 'dark-navy-enduro-sharps',
    theme: 'light'
  },
  {
    title: 'Shirt',
    image: '/static/images/enduros/products-breakdown-shirt.jpg',
    handle: 'white-enduro-shirt',
    theme: 'light'
  },
  {
    title: 'Fives',
    image: '/static/images/enduros/products-breakdown-fives.jpg',
    handle: 'navy-enduro-fives',
    theme: 'light'
  },
  {
    title: 'T-Shirt',
    image: '/static/images/enduros/products-breakdown-tshirt.jpg',
    handle: 'white-enduro-t-shirt',
    theme: 'light'
  }
]

type Card = {
  title: string
  image: string
  handle: string
  theme: 'light' | 'dark'
}

type CardProps = {
  card: Card
}

function Card({ card }: CardProps) {
  const link = getLink(`/products/${card.handle}`)
  const handleLinkClick = (
    ev: MouseEvent<HTMLAnchorElement>,
    action: string
  ) => {
    ev.preventDefault()
    const firstTimeUser = getIsFirstTimeUser()
    analytics('Click', {
      category: 'Landing Page',
      label: 'Product Breakdown',
      action,
      type: firstTimeUser ? 'new' : 'existing'
    })
    window.open(ev.currentTarget.href)
  }
  return (
    <a
      className={`${styles.ProductsBreakdown__Card} ${
        styles[`theme_${card.theme}`]
      }`}
      href={link}
      onClick={ev => handleLinkClick(ev, card.title)}
      aria-label={`Shop ${card.title}`}
    >
      <h3 className={styles.ProductsBreakdown__CardTitle}>{card.title}</h3>
      <NextImage alt={card.title} src={card.image} width="320" height="438" />
      <p className={styles.ProductsBreakdown__CardText}>Shop now</p>
    </a>
  )
}

type ProductsBreakdownProps = {
  cards?: Card[]
}

function ProductsBreakdown({ cards = CARDS }: ProductsBreakdownProps) {
  return (
    <section className={styles.ProductsBreakdown}>
      <div className={styles.ProductsBreakdown__header}>
        <SectionHeader title="The Enduro Collection" variant="left_aligned" />
      </div>
      {!!cards?.length && (
        <ul className={styles.ProductsBreakdown__products}>
          {cards.map(card => {
            return (
              <li key={card.title}>
                <Card card={card} />
              </li>
            )
          })}
        </ul>
      )}
    </section>
  )
}

export default ProductsBreakdown
